import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadJudges.module.scss";


import Renate from "@cs/public/img/people/Renate-Christ.jpeg";
import JimS from "@cs/public/img/people/JimS.jpg";
import Mirik from "@cs/public/img/people/mirik.jpg";
import Julia from "@cs/public/img/people/Julia_Steinberger.jpg";
import Kathleen from "@cs/public/img/people/Kathleen_Rogers.jpg";
import ZamzamIbrahim from "@cs/public/img/people/Zamzam.jpg";
import KelleyLe from "@cs/public/img/people/KelleyLe.jpg";


import { Person } from "@cs/components/composite/person";
import { UnderlineLink } from "@climate-science/component-library";

const JudgeImages = [
  {
    link: "https://www.linkedin.com/in/renate-christ-b6a7257/",
    image: Renate
  },
  {
    link: "https://www.linkedin.com/in/kathleen-rogers-9133761/",
    image: Kathleen
  },
  {
    link: "https://twitter.com/JKSteinberger",
    image: Julia
  },
  // {
  //   link: "https://www.linkedin.com/in/vaiteacowan/",
  //   image: Vaitea
  // },
  {
    link: "https://www.linkedin.com/in/mirik-gogri-59311333/",
    image: Mirik
  },
  {
    link: "https://www.linkedin.com/in/james-savage-63315540/",
    image: JimS
  },
  {
    link: "https://www.linkedin.com/in/zamzamibrahim/",
    image: ZamzamIbrahim
  },
  {
    link: "https://mobile.twitter.com/drkelleyle",
    image: KelleyLe
  }
];
const JudgeIds = [
  "renate", "kathleen", "julia",
  // "vaitea",
  "mirik",
  "jim",
  "zamzam",
  "kelleyle"
];

const OlympiadJudges: FC = () => {
  const { t } = useTranslation("olympiad");

  return (
    <section className={styles.olympiadSection}>
      <h2 className={styles.olympiadSectionTitle}>{t("final-judges")}</h2>
      <div className={styles.personsGrid}>
        {JudgeIds.map((judgeId, index) => (
          <Person
            key={index}
            image={JudgeImages[index].image}
            href={JudgeImages[index].link}
            name={t(`judges.${judgeId}.name`)}
          >
            <Trans
              t={t}
              i18nKey={`judges.${judgeId}.description`}
              components={[
                <UnderlineLink key="0" href="https://www.ipcc.ch/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="1" href="https://schmidtfutures.com/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="2" href="https://enapter.com/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="3" href="https://www.aarti-industries.com/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="4" href="https://spectrum-impact.org/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="5" href="https://unil.ch/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="6" href="https://earthday.org/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="7" href="https://www.sos-uk.org/"
                  target="_blank" rel="noreferrer" />,
                <UnderlineLink key="8"
                  href="https://scienceproject.cfep.uci.edu/"
                  target="_blank" rel="noreferrer" />
              ]}
            />
          </Person>
        ))}
      </div>
    </section>
  );
};

export default OlympiadJudges;